/**
 * Build the Org dropdown's options, marking organizations that hold no
 * properties as unselectable.
 *
 * `fn_admin_list_organizations` already returns `client_count`, and a platform
 * admin sees all ~150 orgs — several of which are empty shells (e.g. "Test
 * Organization (Dev)"). Offering them as normal choices leads straight to a
 * dead end: the Property dropdown then reads "No properties in this org" and
 * every dashboard renders blank, which is indistinguishable from a broken app.
 *
 * Lives in its own module so it can be unit-tested without pulling AdminHeader's
 * whole dependency tree into the test environment.
 *
 * @param {Array<{id: string, name: string, client_count?: number}>} orgs Active orgs.
 * @returns {Array<{value: string, label: string, disabled?: boolean}>} Options
 *   for `HeaderSelect`, empty orgs labelled and disabled.
 */
export function orgSelectOptions(orgs) {
  return [
    { value: '', label: '— select organization —' },
    ...orgs.map((o) => {
      const empty = Number(o.client_count ?? 0) === 0;
      return {
        value: o.id,
        label: empty ? `${o.name} — no properties` : o.name,
        disabled: empty,
      };
    }),
  ];
}

export default orgSelectOptions;
